import * as O from 'fp-ts/lib/Option';
import {ServiceRequestsApi} from 'Agent/Policies/api';
import {DirectBillingChange} from 'Agent/Policies/api/api';
import {ChangeRequest, matchChangeRequest} from 'Agent/Policies/models/ServiceRequest/ChangeRequest';
import {ValidServiceRequestWithChange} from 'Agent/Policies/models/ServiceRequest/PolicyServiceRequestWithChangeRequest';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';

const serviceRequestApi = new ServiceRequestsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const serviceRequestToApiChangeRequest = (changeRequest: ChangeRequest) =>
  matchChangeRequest(changeRequest, {
    AddressChangeRequest: (address): any => ({
      address: {
        firstName: address.firstName.value,
        middleName: address.middleName.value,
        lastName: address.lastName.value,
        state: address.state.value,
        city: address.city.value,
        street: address.street.value,
        zip: address.zip.value,
      },
    }),
    DirectBillingChangeRequest: (billingChangeRequest): any => ({
      directBillingChange: {
        premiumMode: O.isSome(billingChangeRequest.billingSchedule)
          ? ((billingChangeRequest.billingSchedule.value as unknown) as DirectBillingChange)
          : undefined,
      },
    }),
    PayrollAllotmentChangeRequest: (payroll): any => ({
      payrollAllotmentChange: {
        accountNumber: payroll.accountNumber.value,
        controlNumber: payroll.controlNumber.value,
        payorName: payroll.payorName.value,
        premiumMode: O.isSome(payroll.billingSchedule)
          ? ((payroll.billingSchedule.value as unknown) as DirectBillingChange)
          : undefined,
      },
    }),
  });

export const savePolicyServiceRequest = (
  encryptedIdentifier: string,
  serviceRequest: ValidServiceRequestWithChange
) => {
  return serviceRequestApi
    .sendEmail(
      '1',
      {
        ...serviceRequestToApiChangeRequest(serviceRequest.changeRequest),
        insuredFirstName: serviceRequest.initialPolicyServiceRequestInformation.insuredFirstName.value,
        insuredMiddleName: serviceRequest.initialPolicyServiceRequestInformation.insuredMiddleName.value,
        insuredLastName: serviceRequest.initialPolicyServiceRequestInformation.insuredLastName.value,
        policyNumber: serviceRequest.initialPolicyServiceRequestInformation.policyNumber.value,
        additionalPolicyNumbers: serviceRequest.initialPolicyServiceRequestInformation.additionalPolicyNumbers
          .map(policyNum => policyNum.value.value)
          .join(', '),
      },
      {params: {encryptedIdentifier}, ...getAxiosConfig()}
    )
    .then(handleResponse);
};
